
import { FeedbackCategoryTag, FeedbackMessage, NewFeedbackMessage } from "@/types/feedback";
import { useFeedbackList } from "./feedback/useFeedbackList";
import { useCreateMessage } from "./feedback/useCreateMessage";
import { useUpdateMessage } from "./feedback/useUpdateMessage";
import { useDeleteMessage } from "./feedback/useDeleteMessage";

export const useFeedbackMessages = (categoryFilter: FeedbackCategoryTag = null) => {
  const { messages, isLoading, error } = useFeedbackList(categoryFilter);
  const { createMessage, user } = useCreateMessage();
  const { updateMessage } = useUpdateMessage(messages);
  const { deleteMessage } = useDeleteMessage(messages);
  
  return {
    messages,
    isLoading,
    error,
    createMessage,
    updateMessage,
    deleteMessage,
    user
  };
};
